var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 13,
    viewBox: "0 0 4 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.23999 11.0718C1.23999 10.651 1.58111 10.3098 2.00189 10.3098C2.42268 10.3098 2.7638 10.651 2.7638 11.0718C2.7638 11.4925 2.42268 11.8337 2.00189 11.8337C1.58111 11.8337 1.23999 11.4925 1.23999 11.0718Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.23999 6.50033C1.23999 6.07954 1.58111 5.73842 2.00189 5.73842C2.42268 5.73842 2.7638 6.07954 2.7638 6.50033C2.7638 6.92111 2.42268 7.26223 2.00189 7.26223C1.58111 7.26223 1.23999 6.92111 1.23999 6.50033Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.23999 1.9289C1.23999 1.50811 1.58111 1.16699 2.00189 1.16699C2.42268 1.16699 2.7638 1.50811 2.7638 1.9289C2.7638 2.34969 2.42268 2.6908 2.00189 2.6908C1.58111 2.6908 1.23999 2.34969 1.23999 1.9289Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.9176da897e5b5640f47f89f1521b120c.svg";
export { ForwardRef as ReactComponent };